/*
 * Wod, Worldline Offer Designer.
 * Copyright (C) 2017-2018 Worldline
 * All Rights Reserved
 * This product is protected by copyright. Any copying or distribution
 * is forbidden without the agreement of Worldline.
 */
import { Injectable } from "@angular/core";
import { environment } from 'environments/environment';
import * as _ from "lodash";
import { NGXLogger } from "ngx-logger";

@Injectable()
export class ConfigurationService {

    private _theConfig: any = {};

    constructor(
    ) {
        Object.assign(this._theConfig, environment);
    }

    public load(): Promise<any> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `assets/configuration/${environment.configuration.jsonFileName}`);

            xhr.addEventListener('readystatechange', () => {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    let jsonData = JSON.parse(xhr.responseText);
                    this.overrideConfigWithJSONData(jsonData);
                    resolve(jsonData);
                } else if (xhr.readyState === XMLHttpRequest.DONE) {
                    console.error('ERROR_FETCHING_CONFIGURATION');
                    reject();
                }
            });
            xhr.send(null);
        });
    }


    /**
     * Surcharge la configuration définie dans environment avec les infos présentes dans le json
     * @param jsonData 
     */
    private overrideConfigWithJSONData(jsonData: any) {
        console.info("Now overriding default configuration with json configuration file.");
        this.recursiveOverride(jsonData);
    }

    private recursiveOverride(jsonData: any, pathPrefix?: string) {
        for (var k in jsonData) {
            const fullPath = pathPrefix ? `${pathPrefix}.${k}` : k;
            if (typeof jsonData[k] == "object" && jsonData[k] !== null) {
                this.recursiveOverride(jsonData[k], `${fullPath}`);
            } else {
                // On récupère la valeur à surcharger et on surcharge. On utilise les fonctions de loadash (https://lodash.com/)
                let envProp = _.get(this._theConfig, fullPath);
                // this.log.debug(`Overriding configuration value for key ${fullPath}, env value was [${envProp}], value is now [${jsonData[k]}]`);
                _.set(this._theConfig, fullPath, jsonData[k]);
            }
        }
    }

    public get config() {
        return this._theConfig;
    }
}